/**
 * Component to handle Carousel clicks
 *
 * The module is handling clicks in carousel
 *
 * @module app/components/CarouselHandler
 */
import DeviceDetector from './DeviceDetector';
import jQuery from 'jquery';
import { validateVersion } from '../../utils';

var carouselHandlerActionClickHandler = function carouselHandlerActionClickHandler(e) {
    var clickedItem = jQuery(this);

    var topic = decodeURI(clickedItem.attr('msg-bus-topic'));
    var value = decodeURI(clickedItem.attr('msg-bus-value'));
    try {
        value = JSON.parse(value);
    } catch(ex) {
        // it's text value
    }

    window.WH.messageBus.publish(topic, value);
    e.preventDefault();
};

var hideInvalidCarouselItems = function hideInvalidCarouselItems(platform, currentVersion) {
    var itemClass = '.contextual-nav__item';
    var hiddingClass = 'wh-hide';
    var carouselSelector = 'body #main-container #main #carousel .for' +
        platform.charAt(0).toUpperCase() + platform.slice(1);
    var platformMinVersionAttribute = platform + '-app-min-version';
    var platformMaxVersionAttribute = platform + '-app-max-version';

    jQuery(carouselSelector).find(itemClass).each(function() {
        var linkElement = jQuery(this).children('a').first();

        var versionConstraints = {
            min: linkElement.attr(platformMinVersionAttribute),
            max: linkElement.attr(platformMaxVersionAttribute),
        };

        if(!validateVersion(currentVersion, versionConstraints)) {
            linkElement.parent().addClass(hiddingClass);
        }
    });
};

var startCarouselHandler = function startCarouselHandler() {
    window.WH.messageBus.subscribe('AppJs.domReady', function() {
        jQuery('body').off('click.msgBusPublisher')
            .on('click.msgBusPublisher', 'a.contextual-nav__msg_bus_publisher', carouselHandlerActionClickHandler);
    });
};

var hideCarouselForIPads = function hideCarouselForIPads() {
    return DeviceDetector.isTablet() &&
        DeviceDetector.isNativeCom() &&
        DeviceDetector.isIOS() &&
        validateVersion(DeviceDetector.getAppVersion(), { min: '13.0.0', max: '*' });
};

export default {
    init: function() {
        if (hideCarouselForIPads()) {
            var carousel = jQuery('body #main-container #main #carousel');

            carousel.remove();
            return;
        }

        if (DeviceDetector.isNative()) {
            var appVersion = DeviceDetector.getAppVersion();
            // appVersion is conditionally defined by the native devices
            if (appVersion) {
                var platform = DeviceDetector.isNativeiOS() ? 'ios' : 'android';
                hideInvalidCarouselItems(platform, appVersion);
            }

        }

        startCarouselHandler();

    },
};
